import { MenteeRegistrationIdentity } from './MenteePortalService';

type Props = {
    identity: MenteeRegistrationIdentity;
    studentName?: string | null;
    linkedinUrl: string;
    readOnly: boolean;
    onLinkedinChange: (value: string) => void;
};

const initialsFromName = (name: string | null | undefined) => {
    const text = (name || '').trim();
    if (!text) return '—';
    const parts = text.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
};

const profileMeta = (identity: MenteeRegistrationIdentity, studentName?: string | null) => {
    const bits = [
        identity.programName,
        identity.batchYear != null ? `Year ${identity.batchYear}` : null,
        identity.campusName,
    ].filter(Boolean);
    if (studentName && bits.length === 0) return studentName;
    if (studentName) return bits.join(' · ');
    return bits.join(' · ') || '—';
};

const MenteeRegistrationDetails = ({
    identity,
    studentName,
    linkedinUrl,
    readOnly,
    onLinkedinChange,
}: Props) => {
    const picture = identity.picture ? String(identity.picture).trim() : '';
    const initials = initialsFromName(studentName);
    const programmeDisplay = identity.programName || '—';

    return (
        <section className="mreg-card" aria-labelledby="mreg-details-title">
            <h2 id="mreg-details-title" className="mreg-card-title">
                Your Details
            </h2>
            <div className="mreg-profile">
                {picture ? (
                    <img className="mreg-avatar" src={picture} alt="" />
                ) : (
                    <div className="mreg-avatar mreg-avatar-initials" aria-hidden="true">
                        {initials}
                    </div>
                )}
                <div className="mreg-profile-text">
                    {studentName ? <div className="mreg-profile-name">{studentName}</div> : null}
                    <div className="mreg-profile-meta">{profileMeta(identity, studentName)}</div>
                </div>
            </div>
            <div className="mreg-field-grid">
                <label className="mreg-field">
                    <span className="mreg-field-label mreg-field-label-upper">Programme</span>
                    <input
                        type="text"
                        className="form-control mreg-input-readonly"
                        value={programmeDisplay}
                        readOnly
                        disabled
                        tabIndex={-1}
                    />
                </label>
                <label className="mreg-field">
                    <span className="mreg-field-label mreg-field-label-upper">Campus</span>
                    <input
                        type="text"
                        className="form-control mreg-input-readonly"
                        value={identity.campusName || '—'}
                        readOnly
                        disabled
                        tabIndex={-1}
                    />
                </label>
                <label className="mreg-field mreg-field-full">
                    <span className="mreg-field-label mreg-field-label-upper">
                        LinkedIn Profile <span className="mreg-optional">(optional)</span>
                    </span>
                    <input
                        type="url"
                        className="form-control"
                        value={linkedinUrl}
                        onChange={(e) => onLinkedinChange(e.target.value)}
                        placeholder="linkedin.com/in/your.profile"
                        disabled={readOnly}
                        readOnly={readOnly}
                    />
                </label>
            </div>
        </section>
    );
};

export default MenteeRegistrationDetails;
